import { Audio } from 'expo-av'

import { extendLogger } from './logger'

const logger = extendLogger('AudioService')

const betSound = require('../../../assets/audio/bet.mp3')
const chipsSound = require('../../../assets/audio/chips.mp3')
const foldSound = require('../../../assets/audio/fold.mp3')
const twoTapsSound = require('../../../assets/audio/two-taps.mp3')
const cardPlaceSound = require('../../../assets/audio/card-place.mp3')
const allInSound = require('../../../assets/audio/allin.mp3')
const cardsDealtSound = require('../../../assets/audio/cardsdealt.mp3')
const celebrationSound = require('../../../assets/audio/celebration.mp3')
const pokerChipsSound = require('../../../assets/audio/pokerchips.mp3')
const yourTurnSound = require('../../../assets/audio/yourturn.mp3')

const Sounds = {
  chips: chipsSound,
  fold: foldSound,
  check: twoTapsSound,
  bet: betSound,
  allIn: allInSound,
  cardsDealt: cardsDealtSound,
  cardPlace: cardPlaceSound,
  celebration: celebrationSound,
  pokerChips: pokerChipsSound,
  yourTurn: yourTurnSound
} as const

export type SoundType = keyof typeof Sounds

type SoundOptions = {
  volume?: number //  A number between 0.0 (silence) and 1.0 (maximum volume)
}

export async function playSound(soundName: SoundType, options?: SoundOptions) {
  try {
    const soundSource = Sounds[soundName]

    const audioLoad = await new Audio.Sound().loadAsync(soundSource)

    if (audioLoad.isLoaded) {
      const { sound } = await Audio.Sound.createAsync(
        {
          uri: audioLoad.uri
        },
        {
          shouldPlay: true
        }
      )
      options?.volume && (await sound.setVolumeAsync(options?.volume))
      sound.playAsync()
    }
  } catch (error) {
    logger.error(error)
  }
}
